import PageInfo from './pageInfo'
// import Center from './center'
import PromoInfo from './promo'
import mmpAuth from './mmpAuth'
// import cartInfo from './cartInfo'
import mmpRoute from './mmpRoute'
import loading from './loading'
// 사용자 커스터 마이징
// const register = () => {
//   return [PageInfo, Center, PromoInfo, mmpAuth, cartInfo, mmpRoute, loading]
// }
const register = () => {
  return [PageInfo, PromoInfo, mmpAuth, mmpRoute, loading]
}

let registerLocalStore = {}
registerLocalStore.register = register

export default registerLocalStore



// WEBPACK FOOTER //
// ./src/config/vuex/register.js